export default __webpack_public_path__ + "static/media/diagram.0287b862.svg";